import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Sirve para cualquier edad del gato?',
    a: 'Sí, desde cachorros hasta gatos senior. Solo adaptamos la altura.'
  }, {
    q: '¿Tengo que comprar herramientas?',
    a: 'No. Con una tijera, cinta y soga de ferretería estás perfecto.'
  }, {
    q: '¿Qué pasa si mi gato es muy caprichoso?',
    a: "En la guía te enseñamos a usar 'marcadores de olor' para que lo nuevo le resulte irresistible."
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 md:py-20 px-4 bg-cream" data-id="element-24">
      <div className="max-w-3xl mx-auto" data-id="element-25">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-26">
          <h2 className="text-3xl md:text-4xl mb-4" data-id="element-27">Preguntas Frecuentes</h2>
        </motion.div>

        <div className="space-y-4" data-id="element-28">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white rounded-2xl overflow-hidden shadow-sm" data-id="element-29">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full text-left p-6 flex justify-between items-center focus:outline-none" data-id="element-30">
                <span className="font-bold text-lg md:text-xl pr-4" data-id="element-31">
                  {faq.q}
                </span>
                <ChevronDown className={`text-amber transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} size={24} data-id="element-32" />
              </button>
              <AnimatePresence data-id="element-33">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-34">
                    <div className="p-6 pt-0 text-lg text-warmBrown/80 border-t border-cream" data-id="element-35">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}